$(document).ready(function() {
 
  window.addEventListener('resize', ()=> {
                         
  animateSlide1()
  animateSlide2()
   if (window.innerWidth <= 767) {
                vitaminsMobile()
            } else {
                vitamins()
            }
 
                          	
                          });
  

    animateSlide1();
    $(".custom-slideshow").on(
        "beforeChange",
        function(event, slick, currentSlide, nextSlide) {


            $('.flower1-slide-4,.flower2-slide-4, .vitaminA-slide-3, .vitaminA-bubble-slide-3, .vitaminD3-slide-3, .vitaminD3-bubble-slide-3, .omega-slide-3, .omega-bubble-slide-3').animate({
                opacity: 0
            }, 100);

            if (nextSlide === 0) {


                animateSlide1();

            } else if (nextSlide === 1) {
                animateSlide2()
            } else if (nextSlide === 2) {
                animateSlide3()
            } else {

                animateSlide4();
            }
        }
    );


    $('.custom-slideshow').on('afterChange', function(event, slick, currentSlide, nextSlide) {
        if (currentSlide === 1) {
            $('.vitaminA-slide-3, .vitaminA-bubble-slide-3, .vitaminD3-slide-3, .vitaminD3-bubble-slide-3, .omega-slide-3, .omega-bubble-slide-3').animate({
                opacity: 1,
            }, 100)
            if (window.innerWidth <= 767) {
                vitaminsMobile()
            } else {
                vitamins()
            }
        }
        setTimeout(
            () => {
                $('.flower1-slide-4,.flower2-slide-4').animate({
                    opacity: 1,
                    "transform": "translate(10px,100px)"
                }, 100);
            }, 800
        )
    });



});

//--------Vitamin Scaling-----------//
const scaling= [ {
                scale: 0.5
            },

            {
                scale: 1
            },
            {
                scale: 0.9
            },
            {
                scale: 1
            },
          
      ]
                const delayyDurateEase={
                 duration: 2000,
      			 delay: 300,
 				 easing: "linear",
                }

function vitaminsMobile() {
 

    anime({
        targets: ".vitaminA-slide-3",
		...delayyDurateEase,    
        keyframes: [{
                translateX: ['0', '19.8vw'],
                translateY: ['0', '-16.4vw'],
            },      
            ...scaling           
        ],
      



    });
    anime({
        targets: ".vitaminD3-bubble-slide-3",
		...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '20vw'],
                translateY: ['0', '-16vw'],
            },
 ...scaling
         
        ],
    });
    anime({
        targets: ".vitaminD3-slide-3",
     ...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '-13.4vw'],
                translateY: ['0', '-16.6vw'],
            },
 ...scaling
        ],
    });
    anime({
        targets: ".vitaminA-bubble-slide-3",
        ...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '-13.4vw'],
                translateY: ['0', '-16.6vw'],
            },

            ...scaling
        ],

    });
    anime({
        targets: ".omega-slide-3",
       ...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '26vw'],
                translateY: ['0', '-0.8vw'],
            },

            ...scaling
        ],

    });
    anime({
        targets: ".omega-bubble-slide-3",
       ...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '26vw'],
                translateY: ['0', '-0.8vw'],
            },
             ...scaling
        ],
    });
}
 								///Vitamin animations for Desktop///

function vitamins() {
   
    anime({
        targets: ".vitaminD3-slide-3",
		...delayyDurateEase,

        keyframes: [{
                translateX: ['0', '-14.2vw'],
                translateY: ['0', '-13vw']

            },

            ...scaling
        ],

    });
    anime({
        targets: ".vitaminD3-bubble-slide-3",
      ...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '-15vw'],
                translateY: ['0', '-13vw'],
            },

            ...scaling
        ],
 
    });
    anime({
        targets: ".vitaminA-slide-3",
        ...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '15.3vw'],
                translateY: ['0', '-12.1vw']
            },

            ...scaling
        ],
    });
    anime({
        targets: ".vitaminA-bubble-slide-3",
        ...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '16.3vw'],
                translateY: ['0', '-11.4vw']
            },

            ...scaling
        ],
    });
    anime({
        targets: ".omega-slide-3",
     	 ...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '17.4vw'],
                translateY: ['0', '-0.5vw']


            },

             ...scaling
        ],

    });
    anime({
        targets: ".omega-bubble-slide-3",
        ...delayyDurateEase,
        keyframes: [{
                translateX: ['0', '18vw'],
                translateY: ['0', '0vw']

            },
            ...scaling
        ],
    });
}


function animateSlide4() {
    anime({
        targets: ".text-slide-1",
        translateX: [200, 0],
        duration: 600,
        opacity: [0, 1],
        easing: "linear",
    });

    anime({
        targets: ".bottle",
        translateY: [-150, 0],
        duration: 2000,
        opacity: [0, 1],

        autoplay: true,
    });

    anime({
        targets: '.splash',
        translateX: ['10%', '0%'],
        translateY: ['5%', '0%'],
        rotate: [8, 0],
        backgroundSize: ['80%', '100%'],
        easing: 'easeInOutSine',
        opacity: 1,
        duration: 3000,
        loop: true,
        direction: 'alternate'
    })

    anime({
        targets: ".softgels,.softgels1,.softgels2",
        duration: 1000,
        translateX: [`${Math.random(0,115)}`, `${Math.random(0,115)}`],
        translateY: [`${Math.random(0,115)}`, `${Math.random(0,115)}`],

        easing: "easeInOutSine",
        direction: 'alternate',
        loop: true


    })

}

//Slide 1 Animations//

const slide1Data= {delay: 500,
            duration: 800,
            opacity: [0, 1],
                    easing: "linear"
                  }

function animateSlide1() {

    if (window.innerWidth <= 767) {

        anime({
            targets: '.splash-slide-2',
            width: ['0%', '47.4%'],
            easing: 'linear',
            duration: 1000
        });
    } else {
        anime({
            targets: '.splash-slide-2',
            width: ['0%', '38.9%'],
            easing: 'linear',
            duration: 1000
        });
    }

    if (window.innerWidth <= 767) {
        anime({
            targets: ".epa-slide-2",
           ...slide1Data,
            translateX: ['0%', '19.5vw'],
        });
     anime({
            targets: ".epa-bubble-slide-2",
        	...slide1Data,
            translateX: ['0%', '19.75vw'],
    });

        anime({
            targets: ".dha-slide-2",
           ...slide1Data,
            translateX: ['0%', '-16vw'],
            translateY: ['0%', '-15.5vw'],
        });

        anime({
            targets: ".dha-bubble-slide-2",
         ...slide1Data,
            translateX: ['0', '-16.2vw'],
            translateY: ['0', '-14.2vw'],
        });
    } else {
    
        anime({
            targets: ".epa-slide-2",
          ...slide1Data,
            translateX: ['0%', '15.8vw'],
            translateY: ['0%', '1.5vw'],
        });

        anime({
            targets: ".epa-bubble-slide-2",
            ...slide1Data,
            translateX: ['0%', '15.8vw'],
            translateY: ['0%', '1.5vw'],
        });

        anime({
            targets: ".dha-slide-2",
 			...slide1Data,
            translateX: ['0%', '-13.1vw'],
            translateY: ['0%', '-10.5vw'],
            easing: "linear",

        });

        anime({
            targets: ".dha-bubble-slide-2",
             ...slide1Data,
            translateX: ['0', '-13.2vw'],
            translateY: ['0', '-10.2vw'],
            easing: "linear",

        });

    }
    anime({
        targets: ".bottle-slide-2,.bottle-shadow-slide-2",
        duration: 700,
        translateX: [-250, 0],
        translateY: [150, 0],
        rotate: ["-50deg", "0"],
        easing: "linear",

    });

    anime({
        targets: ".text-slide-2,.text-slide-2-1,.text-slide-2-2,.text-slide-3-1,.text-slide-3-2,.text-slide-3,.text-slide-4,.text-slide-4-1,.text-slide-4-2",
        translateX: [200, 0],
        duration: 600,
        opacity: [0, 1],
        easing: "linear",
    });

}


function animateSlide2() {

    anime({
        targets: ".bottle-slide-3,.bottle-shadow-slide-3",
        duration: 900,
        translateX: ["-30%", "0%"],
        translateY: ["-30%", "0%"],
        easing: "easeInOutBack",
    });

    anime({
        targets: ".splash-slide-3",
        duration: 900,
        width: ["0%", "46%"],
        easing: "linear",
    });

    anime({
        targets: ".text-slide-3-1,.text-slide-3-2,.text-slide-3",
        translateX: [200, 0],
        duration: 600,
        opacity: [0, 1],
        easing: "linear",
    });

    anime({
        targets: ".softgel-slide-3,.softgel3-slide-3,.softgel2-slide-3",
        duration: 500,
        translateX: [-200, 0],
        opacity: [0, 1],
        easing: "easeInOutSine",
    });


}


function animateSlide3() {

    anime({
        targets: ".bottle-slide-4",
        translateY: ["80%", "0%"],
        duration: 400,
        easing: 'linear'
    })

    anime({



        targets: ".flower1-slide-4,.flower2-slide-4",
        easing: "linear",
        duration: 2000,

        keyframes: [
            {
                scale: [1, 0.8]
            },
            {
                scale: [0.8, 1]
            }
        ],
        loop: true,

    })
    anime({
        targets: '.softgel2-slide-4,.softgel3-slide-4',
        translateX: [400, 0],   
        duration: 400,
        easing: 'linear'
    })

    anime({
        targets: '.softgel-slide-4',
        translateX: [-400, 0],
        duration: 400,
        easing: 'linear'
    })
    anime({
        targets: '.splash-slide-4',
        translateY: ['-35%', '0%'],

        easing: 'linear',
        duration: 400
    })
    anime({
        targets: ".text-slide-4,.text-slide-4-1,.text-slide-4-2",
        translateX: [200, 0],
        duration: 600,
        opacity: [0, 1],
        easing: "linear",
    });
}